module.exports = {"expand":"Rozbalit","hide":"Sbalit","up":"Nahoru","down":"Dolů","navigationTitle":"Navigace"}